import React from 'react';
import { SimpleAudioFileFragment } from '~/graphqlTypes/SimpleAudioFileFragment';
import { SimpleBlipFragment } from '~/graphqlTypes/SimpleBlipFragment';
// import { Button, Popover } from 'react-bootstrap';
import { BEM, renderClassName } from '@feedfm/feed-util';
import './SongInfo.scss';

const bem = new BEM( 'echo-chamber' );
interface SongInfoProps {
  song: SimpleAudioFileFragment | SimpleBlipFragment | null;
}

export const SongInfo: React.FC<SongInfoProps> = ( { song } ) => {
  // const [showPopover, setShowPopover] = useState( false );

  if ( !song || Object.keys( song ).length === 0 ) {
    return <></>;
  }
  const title = 'title' in song ? song.title : song.audioFile.title;
  const artistName = 'artist' in song ? song.artist.name : song.audioFile.artist.name;

  return (
    <div className={ renderClassName( bem.el( 'song-info' ) ) }>
      <span className="song-title">{ title }</span>
      <span className="song-artist">{ artistName }</span>
      { /* ellipses button that opens a popover */ }
    </div>
  );
};
